import React from 'react';
import { useHistory } from 'react-router-dom';
import { useOnMount } from '@chaser/components';
import LoadingMessage from '../../components/LoadingMessage';
import AuthenticationService from '../../services/authentication-service';
import usePush from '../../hooks/usePush';
import useUser from '../../hooks/useUser';

const LoginGoogle = () => {
  const { isLoggedIn } = useUser();
  const { execute } = usePush(AuthenticationService.loginGoogle);
  const history = useHistory();

  async function login() {
    const [err, res] = await execute();

    if (err) {
      history.push('/login', {
        loginError:
          'Sorry. There’s an issue signing you in with Google right now. Please try again in a moment.',
      });
      return;
    }

    const { url } = res;
    window.location.replace(url);
  }

  useOnMount(() => {
    if (isLoggedIn) {
      history.replace('/');
    } else {
      login();
    }
  });

  return <LoadingMessage center useLogoAnimation />;
};

export default LoginGoogle;
